// PERF PASS 3 (2026-11-02): tiny load-time telemetry. Boot, the Run Setup pre-build and Start Run record how long each
// phase took (ms) into window.__loadStats, read by ?loadflow / ?hitchcheck and the F3 overlay. Render / app side only.
const stats: Record<string, number> = {};
const W = typeof window !== 'undefined' ? (window as unknown as { __loadStats?: Record<string, number> }) : null;
if (W) W.__loadStats = stats;

/** record a duration (ms) under `name` (later calls with the same name overwrite) */
export function put(name: string, ms: number): void { stats[name] = Math.round(ms * 10) / 10; }
/** time a synchronous step */
export function timed<T>(name: string, fn: () => T): T { const t0 = performance.now(); try { return fn(); } finally { put(name, performance.now() - t0); } }
/** time an async step */
export async function timedAsync<T>(name: string, fn: () => Promise<T>): Promise<T> { const t0 = performance.now(); try { return await fn(); } finally { put(name, performance.now() - t0); } }
/** record the JS heap (MB, Chrome only) at a named point */
export function heapMark(name: string): void {
  const m = (performance as unknown as { memory?: { usedJSHeapSize: number } }).memory;
  if (m) stats[`heap.${name}`] = Math.round(m.usedJSHeapSize / 1048576);
}
/** a snapshot of everything recorded so far */
export function loadStats(): Record<string, number> { return { ...stats }; }
